import { paginate } from "consts/table";
import { useSearchParams } from "infrastructure/router";
import type { PaginatableFilterType } from "ui/widgets/Filters";

type UsePaginateArgs = {
    readonly fetchData: (urlSearchParams?: URLSearchParams) => Promise<void>;
};

export default function usePaginate({ fetchData }: UsePaginateArgs) {
    const [urlSearchParams, setUrlSearchParams] = useSearchParams();

    return (pgParams: Partial<
        Record<
            PaginatableFilterType,
            | number
            | string
            | undefined
        >
    >) => {
        for (const param of (paginate as Array<PaginatableFilterType>)) {
            if (param in pgParams) {
                urlSearchParams.set(param, `${pgParams[param]}`);
            }
        }

        setUrlSearchParams(urlSearchParams);

        fetchData(urlSearchParams);
    };
};
